

import React from "react";

const CdssIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
  <path fill="none" d="M0 0h24v24H0z"/>
  <path d="M19 5h-3V3H8v2H5c-1.11 0-1.99.89-1.99 2L3 19c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V7c0-1.11-.89-2-2-2zm0 14H5V8h14v11z" fill="#03579E"/>
</svg>
  );
};

export default CdssIcon;
